'use strict';
import $ from 'jquery';
import 'slick-carousel';

export default class M73 {
  static init() {
    $('.module-m73').each((index, el) => {
      new M73($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.dots = this.el.find('.module-m73-stats-dots');
    this.stats = this.el.find('.module-m73-stats');
    this.makeCarousel();
    $(window).on('resize', this.makeCarousel.bind(this));
  }

  makeCarousel() {
    if (this.el.find('.module-m73-stats-stat').length > 4 || $(window).width() < 768) {
      let autoplaySpeed = 4500;
      this.stats.slick({
        rows: 1,
        slidesPerRow: 1,
        arrows: false,
        mobileFirst: true,
        dots: false,
        autoplay: true,
        speed: autoplaySpeed,
        autoplaySpeed: 0,
        cssEase: 'linear',
        useTransform: true,
        appendDots: this.dots,
        infinite: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1420,
            settings: {
              slidesToShow: 3.5,
            },
          },
        ],
      });
    }
  }
}
